import { render, staticRenderFns } from "./EditAddSubCategory.vue?vue&type=template&id=9f220d3e&"
import script from "./EditAddSubCategory.vue?vue&type=script&lang=js&"
export * from "./EditAddSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports